<template>
  <div class="im">
    <div class="im-box">
      <div class="content" ref="imContent">
        <van-pull-refresh class="pull-list" v-model="isLoading" @refresh="onRefresh">
          <div class="clearfix chat-list">
            <template v-for="(item, index) in historyMsgList">
              <msg-card
                :key="index"
                @error="handleError(item)"
                :error="item.error"
                :loading="item.loading"
                :direction="item.direction"
              >
                <div>
                  <div v-if="item.body.type==='ticket'">
                    <div>{{$t('im.处理进度')}}{{item.body.status==1?$t('im.处理中') + '…':item.body.status==2?$t('im.处理完成') :$t('im.待补充相关信息') + '…' }}</div>
                    <div>
                      <div>{{ $t('im.问题分类') }}{{item.body.group_name}}</div>
                      <div>{{ $t('im.提交时间') }}{{item.body.add_time_str}}</div>
                      <div v-if="item.body.status==1">{{ $t('im.预计答复时间') }}{{item.body.pre_time}}</div>
                      <div v-if="item.body.status==2">{{ $t('im.答复时间') }}{{item.body.reply_time}}</div>
                    </div>
                    <div>
                      <a v-if="item.body.status==1" :href="item.body.link">
                      {{ $t('im.客服正在紧急处理中') }}>>
                      </a>
                      <a v-if="item.body.status==2" :href="item.body.link">{{ $t('im.该问题已经处理完成') }}>></a>
                      <a v-if="item.body.status==3" :href="item.body.link">{{ $t('im.需要您配合补充相关信息') }}>></a>
                    </div>
                  </div>
                  <div v-else>
                    <div @click="handleClick" v-html="item.body && item.body.content"></div>
                    <div v-if="item.body.menu && item.body.menu.length">
                      <ul class="menus">
                        <template v-for="(m,i) in item.body.menu">
                          <li @click="onSubmit(m.question)" class="menus-item" :key="i">{{m.question}}</li>
                        </template>
                      </ul>
                    </div>
                  </div>
                  <div
                    class="quote-box"
                    v-if="item.body.quote_info"
                    @click="handleQuoteInfo(item.body.quote_info)"
                  >
                    <i class="kf-huifu1"></i>
                    {{ item.body.quote_info | curQuoteInfo }}
                  </div>
                
                  <MsgOption
                    v-if="item.body.type==='robot' && item.body.status=='parsed' && item.body.save==1"
                    @change="handleHelpChange"
                    :msg_id="item._id"
                    :grade="item.body && item.body.grade"
                  />
                </div>
              </msg-card>
            </template>
            <van-divider :style="{ color: '#8c8c8c', borderColor: '#8c8c8c', padding: '0 16px' }" v-if="historyMsgList.length">{{ $t('im.以下为本次消息') }}</van-divider>
          </div>
          <!-- 欢迎语 -->
          <div class="clearfix chat-list" v-if="welcomeMsg.body">
            <msg-card direction="left">
              <div v-html="welcomeMsg.body && welcomeMsg.body.content"></div>
            </msg-card>
          </div>
          <!-- 猜你想问 -->
          <!-- <div class="guess-question" v-if="guessQuestions.length">
            <div class="title">{{$t('im.猜你想问')}}</div>
            <div class="question" @click="onSubmit(item.title)" v-for="item in guessQuestions" :key="item.id"> <span class="dot"></span> {{item.title}}</div>
          </div> -->
          <div class="clearfix chat-list">
            <template v-for="(item, index) in msgList">
              <msg-card
                :key="index"
                @error="handleError(item)"
                :error="item.error"
                :loading="item.loading"
                :direction="item.direction"
                v-if="item.body.isQueue && queue || !item.body.isQueue"
              >
                <div>
                  <div
                    @click="handleClick"
                    v-html="item.body && item.body.content"
                  >
                  </div>
                  <div v-if="item.body.menu && item.body.menu.length">
                    <ul class="menus">
                      <template v-for="(m,i) in item.body.menu">
                        <li @click="onSubmit(m.question)" class="menus-item" :key="i">{{m.question}}</li>
                      </template>
                    </ul>
                  </div>
                  <div
                    class="quote-box"
                    v-if="item.body.quote_info"
                    @click="handleQuoteInfo(item.body.quote_info)"
                  >
                    <i class="kf-huifu1"></i>
                    {{ item.body.quote_info | curQuoteInfo }}
                  </div>
                  <div v-if="item.body.selfHelp">
                    <van-button @click="handleSelfHelp" class="self-help-btn" type="primary">{{ $t('im.自助提交') }}</van-button>
                  </div>
                  <div class="queue" v-if="item.body.isQueue && queue">
                    {{ $t('im.正在为您接入') }} <span class="num">{{ $t('im.第') }}{{queue}}{{ $t('im.位') }}</span>
                    <div class="exit" @click="exitQueue">{{ $t('im.取消排队') }}</div>
                  </div>
                </div>
                <MsgOption
                    v-if="item.body.type==='robot' && item.body.status=='parsed' && item.body.save==1"
                    @change="handleHelpChange"
                    :msg_id="item._id"
                    :grade="item.body && item.body.grade"
                  />
              </msg-card>
            </template>
          </div>
        </van-pull-refresh>
      </div>

      <div class="input-box">
        <send-msg
          ref="sendmsg"
          show-other
          :cdn="vuexInitData.cdn_img_url"
          :isLike="!isAllot"
          @focus="goBottom"
          @uping="handleUping"
          @imgSuccess="handleUpload($event, 'img')"
          @videoSuccess="handleUpload($event, 'video')"
          @submit="onSubmit"
        ></send-msg>
      </div>
    </div>
    <van-popup
      v-if="imNotice"
      v-model="show"
      position="top"
      :style="{ top: getPopupTop + 'px' }"
    >
      <div class="notice-title" v-html="imNotice.title"></div>
      <div class="notice-date">{{ imNotice.up_time | dateFormat }}</div>
      <div class="notice-content" v-html="imNotice.content"></div>
      <div class="notice-ok-btn" @click="show = false">{{$t('im.我知道了')}}</div>
    </van-popup>
    <ImNotice
      :visible="imNoticeVisible"
      :data="imNoticeData"
      @close="handleCancel"
      @ok="handleImNotice"
    />
    <ImNotice
      :visible="nightNoticeVisible"
      :type="'night'"
      :data="nightNoticeData"
      @close="handleCancel"
      @feedBack="handleNightFeed"
    />
    <FeedBack
      @submit="handleTransfer"
      :feedType="feedType"
      :reason="vuexInitData.access_reason"
      ref="feedBack"
    />
    <van-overlay z-index="1000" :show="quoteShow" @click="quoteShow = false">
      <div class="wrapper" v-html="currentQuoteInfo">
      </div>
    </van-overlay>
  </div>
</template>

<script>
  import { goScrollView, createBase64Img, dateFormat, ellipsisHtml } from '@/utils/util';
  import {
    // apiImGetBaseInfo,
    apiImGetHistoryMessage,
    // apiImInit,
    apiKfIndex,
    apiKfSendRobotMessage,
    apiKfTransferToService,
    apiGetImNotice,
    apiFeedBackNight,
    // apiGuessQuestion,
    apiMessageTips
  } from '@/api/Im';
  import { mapGetters,mapActions } from 'vuex';
  import scrollMixin from '@/utils/scrollMixin';
  import MsgCard from '@/components/MsgCard';
  import MsgOption from './msgOption';
  import { ImNotice } from '@/components/Notice';
  import FeedBack from './feedBack';
  import storage from '@/utils/storage';
  export default {
    data() {
      return {
        show: false,
        initData: null,
        app_id: 1001,
        imNotice: null,
        // formList: [],
        chatList: [],
        // 消息列表
        msgList: [],
        // 历史消息
        historyMsgList: [],
        // 欢迎消息
        welcomeMsg: {},
        // faqTab: 0,
        // faqTabList: [],
        // faqList: [],
        isLoading: true,
        // 公告消息visible
        imNoticeVisible: false,
        // 是否初始化完成，完成后再将form-list展示出来，否则会先贴在顶部
        isInitFinish: false,
        // 夜间公告visible
        nightNoticeVisible: false,
        // 公告数据
        imNoticeData: null,
        // 夜间公告数据
        nightNoticeData: null,
        webSocket: null,
        // 排队数
        queue: 0,
        // 是否已分配
        isAllot: false,
        // 分配的客服id
        admin_id: '',
        // 任务id
        tid: '',
        // 重连次数
        reconnectionCount: 0,
        // 心跳定时器
        heartTimeout: null,
        heartServerTimeout: null,
        // 重连定时器
        reConnInterval: null,
        connectStatus: -1,
        // normal为普通转人工弹窗，night为夜间反馈
        feedType: 'normal',
        // 引用的内容展示
        currentQuoteInfo: '',
        // 引用visible
        quoteShow: false,
        // 是否正在获取init数据
        isGetInitInfo: false,
        // 猜你想问
        guessQuestions: [],
        // 回复tips
        messageTips: {},
        // 退出类型
        endType: ''
      };
    },
    mixins: [scrollMixin],
    components: { MsgCard, ImNotice, FeedBack, MsgOption },
    computed: {
      ...mapGetters(['defaultRoleInfo', 'vuexInitData', 'globalNotice']),
      getPopupTop() {
        return Math.floor((this.outerWidth / 375) * 44);
      },
      getFormListTop() {
        let height= document.getElementsByClassName('nav')[0] && document.getElementsByClassName('nav')[0].offsetHeight || 88;
        return height;
      }
    },
    filters: {
      curQuoteInfo (val) {
        let str = ellipsisHtml(val, 20);
        if (val.search('<img') > -1) {
          str += `[${this.$t('im.图片')}]`;
        }
        if (val.search('<video') > -1) {
          str += `[${this.$t('im.视频')}]`;
        }
        return str;
      }
    },
    watch: {
      defaultRoleInfo(val){
        if (this.webSocket) {
          this.closeSocket();
          this.isAllot = false;
          this.tid = '';
        }
        window.location.reload();
        // this.getHistoryMessage();
        // this.getImInitData();
        // this.msgList = [];
      }
    },
    async mounted() {
      await this.getKfInit();
      await this.getImInitData();
      // await this.getHistoryMessage();
      // 已经在排队中
      if (this.vuexInitData.im_task && this.vuexInitData.im_task.id) {
        this.handleWebSocket(this.vuexInitData.im_task.id);
      }
      // 是否已分配
      if ( this.vuexInitData.im_task && this.vuexInitData.im_task.allot_time &&this.vuexInitData.im_task.service_admin) {
        this.isAllot = true;
      }
      this.tid = this.vuexInitData.im_task.id || window.sessionStorage.getItem('taskId');
      // const wbeSocket = new WebSocketClass({url: 'ws://10.0.6.6:7274/'});

      // 添加欢迎语
      this.welcomeMsg = {
        direction: 'left',
        body: { content: this.vuexInitData.welcome || this.$t('im.欢迎您') },
      };
      // await this.getGuessQuestion();
      this.getMessageTips();
      // 滚到底部
      this.goBottom();
    },
    methods: {
      ...mapActions(['getKfInit']),
      async getImInitData() {
        let params = {
        };
        await apiKfIndex(params).then((res) => {
          if (res.code === 0) {
            this.initData = res.data;
            this.imNotice = res.data.notice;
          }
        });
      },
      // 获取历史消息
      async getHistoryMessage(more) {
        let params = {
          app_id: this.app_id,
          sess_uuid: this.vuexInitData.sess_uuid,
          im_role_id: this.defaultRoleInfo.id,
          last_id: (more && this.historyMsgList[0]) ? this.historyMsgList[0]._id : ''
        };
        await apiImGetHistoryMessage(params).then((res) => {
          if (res.code === 0) {
            if (!more) {
              this.historyMsgList= [];
            }
            res.data.forEach((item) => {
              this.historyMsgList.unshift(this.createPushMsg({ msg: item }));
            });
            if (!more && this.historyMsgList && this.historyMsgList.length) {
              setTimeout(() => {
                this.goBottom();
              }, 200);
            }
            
          }
        }).finally(() => {
          this.isInitFinish = true;
        });
      },
      // 获取猜你想问
      // async getGuessQuestion() {
      //   await apiGuessQuestion().then(res => {
      //     if (res.code === 0) {
      //       this.guessQuestions = res.data;
      //     }
      //   });
      // },
      // 获取各种回复tips
      getMessageTips(){
        apiMessageTips().then(res => {
          if (res.code === 0) {
            this.messageTips = res.data;
          }
        });
      },
      // 发送
      onSubmit(value) {
        if (!value) {
          this.$toast(this.$t('im.请输入内容'));
          return;
        }
        if (this.isGetInitInfo) {
          this.$toast(this.$t('im.正在转接'));
          return;
        }
        if (this.isAllot) {
          // websocket 聊天
          this.sendWsMsg(value);
        } else {
          let msg = this.createSendMsg({ type: 'say', content: value });

          let myMsg = this.createPushMsg({ msg, loading: true });
          this.msgList.push(myMsg);
          this.goBottom();
          // 清空输入框
          this.$refs.sendmsg.clearValue();
          this.sendRobotMsg(msg, );
        }
      },
      // 机器人聊天
      sendRobotMsg(msg){
        apiKfSendRobotMessage(msg).then((res) => {
          if (res.code === 0) {
            this.msgList.forEach(item => {
              if (item.body.tmp_id === msg.body.tmp_id) {
                item.loading = false;
              }
            });
            // 人工回复
            // 是否主动转人工
            if (res.data.answer && res.data.answer.body.type==='robot' && res.data.answer.body.status==='switch_to_service'){
              this.checkNotice();
            } else {
              this.msgList.push(this.createPushMsg({ msg: res.data.answer, loading: false }));
            }
            this.goBottom();
          }
        }).catch(err => {
          this.msgList.forEach(item => {
            if (item.body.tmp_id === msg.body.tmp_id) {
              item.loading = false;
              item.error = true;
            }
          });
        });
      },
      // 人工聊天
      sendWsMsg(msg) {
        let tmp_id = new Date().getTime();
        let msgObj = this.createSendMsg({ type: 'say', content: msg });
        if (this.webSocket) {
          this.webSocket.send(JSON.stringify(msgObj));
        } else {
          this.$toast(this.$t('im.人工服务已断开'));
        }
        this.msgList.push(this.createPushMsg({ msg: msgObj }));
        this.goBottom();
        this.$nextTick(() => {
          this.$refs.sendmsg.clearValue();
        });
      },
      // 点击消息重发
      handleError(obj) {
        obj.loading = true;
        obj.error = false;
        if (this.isAllot) {
          if (this.webSocket) {
            this.webSocket.send(JSON.stringify(obj));
          } else {
            this.$toast(this.$t('im.人工服务已断开'));
          }
        } else {
          apiKfSendRobotMessage(obj).then(res => {
            if (res.code === 0) {
              obj.loading = false;
            }
          }).catch(err => {
            obj.loading = false;
            obj.error = true;
          });
        }
      },
      // 点击消息 代理事件监听
      handleClick(e) {
        let className = e.target.className;
        // 检查是否是转人工
        if (className && className === 'switch_to_service') {
          if (this.queue) {
            this.$toast(this.$t('im.您正在排队中'));
            return;
          }
          if (this.isAllot) {
            this.$toast(this.$t('im.您已经在人工聊天'));
            return;
          }
          this.checkNotice(); 
        }
      },
      // 检测公告 判断是否能转人工
      checkNotice() {
        this.feedType = 'normal';
        apiGetImNotice().then((res) => {
          if (res.code === 0) {
            const { im_notice, night_notice } = res.data || {};
            this.imNoticeData = im_notice || null;
            this.nightNoticeData = night_notice || null;
            if (this.nightNoticeData) {
              Object.assign(this.nightNoticeData, { title: this.$t('im.夜间公告') });
            }
            if (this.imNoticeData) {
              this.imNoticeVisible = true;
            } else if (this.nightNoticeData) {
              this.nightNoticeVisible = true;
            } else {
              this.$refs.feedBack.showFeedBack = true;
            }
          }
        });
      },
      // 下拉刷新
      async onRefresh() {
        await this.getHistoryMessage('more');
        this.isLoading = false;
      },
      // 公告点击下一步
      handleImNotice() {
        if (this.nightNoticeData) {
          this.imNoticeVisible = false;
          this.nightNoticeVisible = true;
        } else {
          this.imNoticeVisible = false;
          this.nightNoticeVisible = true;
          this.$refs.feedBack.showFeedBack = true;
        }
      },
      // 公告关闭
      handleCancel() {
        if (this.feedType === 'night' || this.nightNoticeVisible) {
          const msg = {
            body: {
              content: this.messageTips.close_announcement,
              selfHelp: true
            },
            is_admin: 1
          };
          this.msgList.push(this.createPushMsg({ msg, loading: false }));
          this.goBottom();
        }
        this.imNoticeVisible = false;
        this.nightNoticeVisible = false;
        this.imNoticeData = null;
        this.nightNoticeData = null;
      },
      // 转人工
      handleTransfer(option) {
        // 判断是否绑定角色
        if (!this.defaultRoleInfo.id) {
          this.$router.push({
            name: 'BindRoles'
          });
          return;
        }
        if (this.feedType === 'night') {
          const params = {
            phone: this.vuexInitData && this.vuexInitData.user_info && this.vuexInitData.user_info.phone,
            reason_id: Number(option.type),
            remark: option.msg,
            role_name: this.defaultRoleInfo.role_name,
            server_id: this.defaultRoleInfo.f_id
          };
          apiFeedBackNight(params).then(res => {
            if (res.code === 0) {
              this.$refs.feedBack.showFeedBack = false;
            }
          });
        } else {
          // 判断是否能转人工
          if (this.vuexInitData.can_transfer) {
            apiKfTransferToService({
              app_id: this.app_id,
              im_role_id: this.defaultRoleInfo.id,
              sess_uuid: this.vuexInitData.sess_uuid,
              form_wechat: 0,
              reason_id: Number(option.type),
              remark: option.msg,
            }).then((res) => {
              if (res.code === 0) {
                this.getKfInit();
                this.$refs.feedBack.showFeedBack = false;
                // 任务id
                let tid = res.data.id;
                this.tid = tid;
                window.sessionStorage.setItem('taskId', tid);
                this.handleWebSocket(tid);
              }
            });
          }
        }
      },
      // 链接 websocket
      handleWebSocket(tid) {
        if (!Reflect.has(window, 'WebSocket')) {
          console.log(this.$t('im.您的浏览器不支持'));
        }
        // 清除重连定时器
        this.reConnInterval && clearInterval(this.reConnInterval);
        let _this = this;
        // 链接 websocket
        this.webSocket = new WebSocket(this.vuexInitData.ws_uri);

        this.connectStatus = 0;
        // 连接成功
        _this.webSocket.onopen = this.webSocketOnopen;
        // 监听消息
        _this.webSocket.onmessage = this.webSocketOnmessage;

        // 连接关闭
        _this.webSocket.onclose = () => {
          this.connectStatus = -1;
          if (this.isAllot) {
            this.reLinkSocket();
          }
        };

        // 连接错误
        _this.webSocket.onerror= () => {

          this.connectStatus = -1;
          this.reLinkSocket();
        };
      },
      // 链接成功
      webSocketOnopen() {
        let _this = this;
        _this.connectStatus = 1;
        _this.webSocket.send(
          JSON.stringify({
            appid: _this.appid,
            game_id: storage.getGameId(),
            token: localStorage.getItem('token'),
            login_type: 'player',
            rb_id: _this.defaultRoleInfo.id,
            sess_uuid: _this.vuexInitData.sess_uuid,
            tid: _this.tid,
            source: 0,
            type: 'login',
          })
        );
      },
      // websocket 接收消息
      webSocketOnmessage(e) {
        let _this = this;
        let data = JSON.parse(e.data);
        // 判断消息类型
        // 心跳
        this.heartCheck();
        if (data.type === 'ping') {
          _this.webSocket.send(
            JSON.stringify(this.createPong())
          );
        } else if (data.type === 'notice') {
          let _type = data.body.type;
          if (_type === 'queue') {
            let n = _this.queue;
            _this.queue = typeof data.body.queue === 'number'?data.body.queue + 1:false;
            if (!n && _this.queue) {
              const msg = {
                body: {
                  type: 'system',
                  isQueue: true
                }
              };
              _this.msgList.push(this.createPushMsg({ msg, loading: false }));
              _this.goBottom();
            }
          } else if (_type === 'allot') {
            // 人工分配成功
            _this.isAllot = true;
            _this.admin_id = data.body.admin_info && data.body.admin_info.admin_id;
            _this.queue = false;
            _this.msgList.push(this.createPushMsg({ msg: data, loading: false }));
            _this.goBottom();
          } else if (_type === 'end') {
            // 清除重连定时器
            this.reConnInterval && clearInterval(this.reConnInterval);
            // 清除心跳包定时器
            this.heartTimeout && clearTimeout(this.heartTimeout);
            this.heartServerTimeout && clearTimeout(this.heartServerTimeout);
            // 关闭 websocket
            _this.webSocket.close();
            _this.isAllot = false;
            _this.webSocket = null;
            _this.queue = 0;
            // 退出人工
            if (this.endType === 'exit_queue') {
              const msg = {
                body: {
                  content: this.messageTips.quit_queue,
                  selfHelp: true
                },
                is_admin: 1
              };
              _this.msgList.push(this.createPushMsg({ msg, loading: false }));
              _this.goBottom();
              this.endType = '';
            }

          } else if (_type === 'switch') {
            this.tid = data.body.tid;
            this.admin_id = data.body.toAdmin;
            this.isGetInitInfo = true;
            this.getKfInit().finally(() => {
              this.isGetInitInfo = false;
            });
          }
          // else if (_type == 'system') {
          //   data.is_admin = 1;
          //   _this.msgList.push(this.createPushMsg({ msg: data, loading: false }));
          // }
        } else if (data.type === 'say') {
          // 收到消息 要回一条 表示已读
          let params = JSON.parse(JSON.stringify(data));
          params.type = 'read';
          _this.webSocket.send(JSON.stringify(params));
          let tmp_id = data.body.tmp_id;
          if (data.body.type !== 'system') {
            for (let i = 0; i < _this.msgList.length; i++) {
              if (_this.msgList[i].body.tmp_id === tmp_id) {
                _this.msgList[i].loading = false;
                return;
              }
            }
          }
          _this.msgList.push(this.createPushMsg({ msg: data, loading: false }));
          _this.goBottom();
        }
      },
      // 断线重连
      // TODO: 严谨写法需要判断主动重连与被动重连情况
      reLinkSocket() {
        console.log('reconnection webscoket function');
        // 清除心跳包定时器
        this.heartTimeout && clearTimeout(this.heartTimeout);
        this.heartServerTimeout && clearTimeout(this.heartServerTimeout);
        // 清除重连定时器
        this.reConnInterval && clearInterval(this.reConnInterval);
        this.reConnInterval = setInterval(() => {
          // 判断是否达到重连次数
          if (this.reconnectionCount < 20) {
            this.handleWebSocket();
            this.reconnectionCount += 1;
          } else {
            clearInterval(this.reConnInterval);
          }
        }, 5000);
      },
      // 心跳包检测
      heartCheck() {
        // 心跳时间与收发内容以后端约定为主
        this.heartTimeout && clearTimeout(this.heartTimeout);
        this.heartServerTimeout && clearTimeout(this.heartServerTimeout);
        this.heartTimeout = setTimeout(() => {
          // 检查 socket 链接状态 才可发送
          if (this.connectStatus === 1) {
            this.webSocket.send(
              JSON.stringify(this.createPong())
            );
          }
          // 如果 5s 内没有返回约定值判定 socket 处于假死状态，重新链接 socket
          this.heartServerTimeout = setTimeout(async () => {
            await this.closeSocket();
            await this.reLinkSocket();
          }, 5000);
        }, 3000);
      },
      // 关闭 WebSocket
      closeSocket() {
        if (this.webSocket) {
          this.webSocket.close();
          this.webSocket = null;
          // 清除重连定时器
          this.reConnInterval && clearInterval(this.reConnInterval);
          // 清除心跳包定时器
          this.heartTimeout && clearTimeout(this.heartTimeout);
          this.heartServerTimeout && clearTimeout(this.heartServerTimeout);
        }
      },
      // 退出排队
      exitQueue() {
        this.endType = 'exit_queue';
        this.webSocket.send(
          JSON.stringify({
            type: 'exit_queue',
            rb_id: this.defaultRoleInfo.id,
            game_id: storage.getGameId(),
            body: { type: 'exit_queue' },
            tid: this.tid,
          })
        );
      // this.webSocket.close();
      },
      // 发图片 或 视频
      handleUpload(option, type) {
        console.log(option, type);
        let { url, tmp_id } = option;
        let msg = '';
        if (type === 'img') {
          msg = this.createSendMsg({
            type: 'say',
            content: `<img src='${url}'>`,
            tmp_id,
          });
        } else if (type === 'video') {
          msg = this.createSendMsg({
            type: 'say',
            content: `<video controls src='${url}'>`,
            tmp_id,
          });
        }
        if (this.webSocket && this.isAllot) {
          // 人工
          this.webSocket.send(JSON.stringify(msg));
        } else {
          // 机器人
          this.sendRobotMsg(msg);
        }
        // this.msgList.push(this.createPushMsg(msg, true));
        this.goBottom();
      },
      // 发送消息
      createSendMsg({ type, content, bodyType = 'text', tmp_id }) {
        let tmpId = tmp_id || new Date().getTime();
        let obj = {
          app_id: this.app_id,
          type: type,
          body: { type: bodyType, content, tmp_id: tmpId },
          rb_id: this.defaultRoleInfo.id,
          game_id: storage.getGameId(),
          tid: this.tid,
          admin_id: this.vuexInitData.im_task.service_admin || this.admin_id || 0,
          sess_uuid: this.vuexInitData.sess_uuid,
          is_admin: false,
          add_time: parseInt(tmpId / 1000),
          add_time_format: dateFormat(tmpId).hms
        };
        return obj;
      },
      // 本地消息
      createPushMsg({ msg, loading = false }) {
        try {
          msg.body.content = msg.body.content.replace(
            '[cdn_img]',
            this.vuexInitData.cdn_img_url + '/'
          );
        } catch (error) {}
        let obj = {
          direction: msg.is_admin ? 'left' : 'right',
          loading,
          error: false,
          ...msg,
        };
        // if (msg.is_admin) {
        //   obj.direction = 'left';
        // } else {
        //   obj.direction = 'right';
        // }
        if (msg.body && msg.body.type === 'system') {
          obj.direction = 'middle';
        }
        return obj;
      },
      createPong(){
        return {
          type: 'pong',
          game_id: storage.getGameId(),
          tid: this.tid,
          token: localStorage.getItem('token'),
        };
      },
      // 在上传中
      handleUping(option) {
        let { file, type, tmp_id } = option;
        console.log(tmp_id);
        let content = '';
        // 图片和视频都要预览， 通过 tmpId 标记消息的唯一性
        if (type === 'img') {
          let img = `<img src='${file.content}'/>`;
          content = this.createSendMsg({
            type: 'say',
            content: img,
            tmp_id: tmp_id,
          });
        } else if (type === 'video') {
          let uploadUrl = URL.createObjectURL(file.file);
          let video = `<video controls src='${uploadUrl}'/>`;
          content = this.createSendMsg({
            type: 'say',
            content: video,
            tmp_id: tmp_id,
          });
        }
        this.msgList.push(this.createPushMsg({ msg: content, loading: true }));
        this.goBottom();
      },
      goBottom() {
        this.$nextTick(() => {
          goScrollView(this.$refs.imContent, 'bottom');
        });
      },
      // 没帮助
      handleHelpChange(type){
        let msg = type === 1? this.messageTips.like : this.messageTips.dislike;
        this.msgList.push({
          direction: 'left',
          body: {content: msg}
        });
        this.goBottom();
      },
      // 夜间公告反馈
      handleNightFeed () {
        this.nightNoticeVisible = false;
        this.feedType = 'night';
        this.$refs.feedBack.showFeedBack = true;
      },
      handleQuoteInfo (html) {
        this.currentQuoteInfo = html;
        this.quoteShow = true;
      },
      // 自助提交
      handleSelfHelp() {
        this.$router.push({
          path: '/report',
          query: {title: this.$t('reportIndex.更多问题'),formToken: 1, id: 1}
        });
        // window.open(`http://kf.yingxiong.com/Mobile/selfSub?game_id=${storage.getGameId()}`);
      }
    },
  };
</script>

<style lang="less" scoped>
.im {
  background: #e9e9e9;
  .scrollMinXin(hidden, auto);
  box-sizing: border-box;
  height: 100%;
}

.content {
  overflow: auto;
  flex: 1;
  .pull-list {
    min-height: 100%;
  }
  .chat-list {
    padding: 0 10px;
  }
}

.history {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 50px;
  line-height: 18px;
  font-size: 12px;
  white-space: normal;
  padding-left: 10px;
  margin-left: 20px;
  border-left: 1px solid rgba(0, 0, 0, 0.1);

  .icon {
    font-size: 24px;
  }
}

// .my-swipe .van-swipe-item {
//   .faq-item {
//     line-height: 40px;
//     background: #fbfbfb;
//     padding: 0 10px;
//     box-sizing: border-box;
//     color: #242424;
//     font-size: 13px;

//     & + .faq-item {
//       border-top: 1px solid #efefef;
//     }
//   }
// }

.comment-box {
  position: fixed;
  z-index: 100;
  right: 0;
  top: 162px;
  display: flex;
  align-items: center;
  background: @red;
  padding: 5px 10px 5px 14px;
  font-size: 20px;
  color: #fff;
  border-radius: 20px 0 0 20px;
  a {
    color: #fff;
  }
}
.queue {
  display: flex;
  align-items: center;
  .status {
    font-size: 12px;
    color: #a9a9a9;
  }
  .num {
    color: #E64B5C;
  }
  .exit {
    color: #3D7EF0;
    margin-left: 20px;
  }
}
.im-box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.input-box {
  // position: fixed;
  width: 100%;
  // bottom: 0;
  z-index: 90;
  background: #fff;
}
.guess-question {
  margin: 10px;
  padding: 12px;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(129, 137, 164, 0.5);
  border-radius: 12px;
  .title {
    font-size: 14px;
    color: #242424;
  }
  .question {
    display: flex;
    align-items: center;
    margin-top: 12px;
    font-size: 13px;
    color: #3D7EF0;
    list-style-type: disc;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    .dot {
      display: inline-block;
      width: 3px;
      height: 3px;
      margin-right: 3px;
      border-radius: 50%;
      background: #3D7EF0;
    }
  }
}
// .faq-card {
//   background: #fff;
//   box-shadow: 0 1px 2px 0 #9b9b9b;
//   border-radius: 12px;
//   overflow: hidden;
//   margin: 10px auto;
//   width: calc(100% - 20px);
// }

.notice-title {
  font-size: 16px;
  padding: 10px;
}

.notice-date {
  padding: 0 10px;
  color: #999;
  font-size: 12px;
}

.notice-content {
  padding: 10px;
  color: #666;
  font-size: 14px;
  height: 25vh;
  .scrollMinXin(hidden, auto);
}

.notice-ok-btn {
  width: 100%;
  height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f7f7f7;
  color: @red;
}

// .form-list {
//   .scrollMinXin(auto, hidden);
//   white-space: nowrap;
//   padding: 10px;
//   background: #e9e9e9;

//   .item {
//     display: inline-flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: space-around;
//     background: #fff;
//     border-radius: 8px;
//     width: 85px;
//     height: 86px;
//     box-shadow: 0 1px 2px 0 #9b9b9b;

//     & + .item {
//       margin-left: 15px;
//     }

//     img {
//       width: 40px;
//       height: 40px;
//       object-fit: contain;
//     }

//     p {
//       width: 100%;
//       text-align: center;
//       padding: 0 5px;
//       color: #242424;
//       box-sizing: border-box;
//     }
//   }
// }
.menus {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: 12px;
  .menus-item {
    margin-top: 5px;
    color: blue;
  }
}
.self-help-btn {
  width: 100%;
  height: 34px;
  margin-top: 10px;
}
</style>
